/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otp_ConsumedInputs */

const en_us2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code has already been used. Request a new one.`)
};

const pt_br2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código já foi usado. Peça um novo.`)
};

const es_419_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese código ya se usó. Pide uno nuevo.`)
};

const pt_pt2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código já foi usado. Pede um novo.`)
};

const fr_fr2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce code a déjà été utilisé. Demandes-en un nouveau.`)
};

const de_de2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Code wurde schon verwendet. Fordere einen neuen an.`)
};

const it_it2_otp_consumed = /** @type {(inputs: Otp_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo codice è già stato usato. Richiedine uno nuovo.`)
};

/**
* | output |
* | --- |
* | "That code has already been used. Request a new one." |
*
* @param {Otp_ConsumedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const otp_consumed = /** @type {((inputs?: Otp_ConsumedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otp_ConsumedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_otp_consumed(inputs)
	if (locale === "es-419") return es_419_otp_consumed(inputs)
	if (locale === "pt-PT") return pt_pt2_otp_consumed(inputs)
	if (locale === "fr-FR") return fr_fr2_otp_consumed(inputs)
	if (locale === "de-DE") return de_de2_otp_consumed(inputs)
	if (locale === "it-IT") return it_it2_otp_consumed(inputs)
	return en_us2_otp_consumed(inputs)
});
export { otp_consumed as "otp.consumed" }